import React from "react";
import { cn } from "../../../lib/utils";
import TimeAgoPill from "./TimeAgoPill";
import { ViewNotesButton } from "./ViewNotesButton";
import { CaseStageActions } from "../../caseStages/components/actions/CaseStageActions";
import { ActionNextStage } from "../../../api/caseStages";

export interface WorkflowStageBannerProps {
  title: string;
  description?: string | React.ReactNode;
  timeAgo?: number;
  /** Elements rendered near title (e.g. View Notes button) */
  notes?: string;
  /** Right side action buttons */
  actions?: ActionNextStage[];
  className?: string;
  customActions?: React.ReactNode;
}

const WorkflowStageBanner: React.FC<
  WorkflowStageBannerProps
> = ({
  title,
  description,
  timeAgo,
  notes,
  actions,
  className,
  customActions
}) => {
  const renderContentArea = () => (
    <div className="min-w-0 flex flex-col gap-0.5">
      <div className="min-w-0 flex items-center gap-2">
        <span className="truncate font-['Inter'] text-base font-semibold leading-6 tracking-normal text-[#0A0A0A]">
          {title}
        </span>

        {notes && notes.length > 0 && <ViewNotesButton note={notes} />}

        {timeAgo ? (
          <TimeAgoPill days={timeAgo.toString()} />
        ) : null}
      </div>

      {description && (
        <div className="font-['Inter'] text-sm font-normal leading-5 tracking-normal text-[#0A0A0A]">
          {description}
        </div>
      )}
    </div>
  );

  const renderActionArea = () => {
    if (!customActions && !actions) {
      return null;
    }

    return (
      <div className="flex flex-none items-center gap-2">
        {customActions}

        {actions && (
          <CaseStageActions actions={actions} />
        )}
      </div>
    );
  };

  return (
    <div
      className={cn(
        "w-full rounded-[14px] border border-[#FDBA74] bg-[#FFF7ED] px-4 py-3",
        "flex items-center justify-between gap-4",
        className
      )}
    >
      {renderContentArea()}
      {renderActionArea()}
    </div>
  );
};

export default WorkflowStageBanner;